<div class="table-container mat-elevation-z8">
  <table mat-table #table [dataSource]="dataSource" style="width: 100%">
    <ng-container matColumnDef="nom">
      <th mat-header-cell *matHeaderCellDef> Nom </th>
      <td mat-cell *matCellDef="let row"> {{row.nom}} </td>
    </ng-container>

    <ng-container matColumnDef="mobile">
      <th mat-header-cell *matHeaderCellDef> Mobile </th>
      <td mat-cell *matCellDef="let row"> {{row.mobile}} </td>
    </ng-container>


    <tr mat-header-row *matHeaderRowDef="['nom','mobile']"></tr>
    <tr mat-row *matRowDef="let row; columns: ['nom','mobile'];" (click)="select(row)"></tr>
  </table>

  <button style="width: 100%;" (click)="newContact()" mat-raised-button color="primary">Le délégué n'exhiste pas sur la liste</button>
  <button style="width: 100%;" (click)="cancel()"  mat-raised-button color="accent">Annulé</button>


</div>
 